import type { KonvaEventObject } from 'konva/lib/Node'
import Konva from 'konva'
import { VisualShape } from 'app/frontend/types/custom/VisualPlan'
import { DEFAULT_STROKE_COLOR } from '../constants'

export type ShapeInteraction = {
  nodeRef: (node: Konva.Node | null) => void
  draggable: boolean
  onMouseDown: (e: KonvaEventObject<MouseEvent>) => void
  onTap: () => void
  onDblClick?: () => void
  onMouseEnter: () => void
  onMouseLeave: () => void
  onDragStart: (e: KonvaEventObject<DragEvent>) => void
  onDragMove: (e: KonvaEventObject<DragEvent>) => void
  onDragEnd: (e: KonvaEventObject<DragEvent>) => void
}

export const isAdditiveClick = (event: {
  shiftKey: boolean
  metaKey: boolean
  ctrlKey: boolean
}) => event.shiftKey || event.metaKey || event.ctrlKey

export const toggleSelection = (selectedIds: string[], id: string) =>
  selectedIds.includes(id)
    ? selectedIds.filter((selectedId) => selectedId !== id)
    : [...selectedIds, id]

export const commonShapeProps = (shape: VisualShape) => ({
  stroke: shape.stroke_rgb ?? shape.rgb ?? DEFAULT_STROKE_COLOR,
  strokeWidth: shape.stroke_width != null ? shape.stroke_width : 3,
  strokeScaleEnabled: false,
})
